<p-breadcrumb
  [model]="[
    { label: 'Atributos', routerLink: ['/variation-attributes'] },
    {
      label: variationAttributeId() ? 'Editar atributo' : 'Novo atributo',
      routerLink: variationAttributeId()
        ? ['/variation-attributes/update/' + variationAttributeId()]
        : ['/variation-attributes/create']
    }
  ]"
  [home]="{ label: '', routerLink: ['/'], icon: 'ph-duotone ph-house text-lg' }"
/>

<form [formGroup]="formGroup" (ngSubmit)="onSubmit()" class="relative">
  <p-toolbar class="mb-5 mt-5">
    <div class="w-full flex flex-wrap justify-between items-center">
      <div>
        @if(variationAttributeId()){
        <h5 class="font-bold">Editar Atributos</h5>
        <p>Confira e atualize informações</p>
        }@else {
        <h5 class="font-bold">Cadastrar Atributos</h5>
        <p>Preencha os campos abaixo para cadastrar</p>
        }
      </div>
      <div class="flex justify-end gap-5 items-center">
        @if(variationAttributeId()){
        <div class="w-full flex items-center gap-1">
          <label for="isActive"> Status: </label><br />
          <div class="flex gap-2 items-center">
            <p-toggleswitch formControlName="isActive" />
            {{ formGroup.get("isActive")!.value ? "Ativo" : "Inativo" }}
          </div>
        </div>
        }
        <div class="flex gap-2">
          <p-button
            label="Cancelar"
            routerLink="/variation-attributes"
            severity="secondary"
            rounded
            class="btn-secondary-outline"
          >
          </p-button>
          <p-button type="submit" label="Salvar" rounded></p-button>
        </div>
      </div>
    </div>
  </p-toolbar>

  <div class="card mt-5 space-y-5">
    <h5 class="font-bold">Informações gerais</h5>

    <div class="w-full">
      <label for="name"> Nome do atributo *</label>
      <input
        pInputText
        type="text"
        formControlName="name"
        class="w-full"
        placeholder="Ex: cor"
      />
      <app-form-error [control]="formGroup.get('name')" />
      <app-form-server-error [control]="formGroup.get('name')" />
    </div>

    <div class="w-full">
      <label for="description"> Descrição</label>
      <input
        pInputText
        type="text"
        formControlName="description"
        class="w-full"
        placeholder="Descreva as principais características do atributo"
      />
      <app-form-error [control]="formGroup.get('description')" />
      <app-form-server-error [control]="formGroup.get('description')" />
    </div>

    <div class="w-full flex items-center gap-1">
      <label for="isRequired"> Obrigatório? </label><br />
      <div class="flex gap-2 items-center">
        <p-toggleswitch formControlName="isRequired" />
        {{ formGroup.get("isRequired")!.value ? "Sim" : "Não" }}
      </div>
      <app-form-error [control]="formGroup.get('isRequired')" />
      <app-form-server-error [control]="formGroup.get('isRequired')" />
    </div>
  </div>

  @if(loading()) {
  <div
    class="absolute inset-0 z-30 flex items-center justify-center bg-black/20 backdrop-blur-sm rounded-lg"
  >
    <p-progress-spinner ariaLabel="loading"></p-progress-spinner>
  </div>
  }
</form>
